export default "__VITE_ASSET__BULO6n0z__"